let _Math = require("../lib/Math");

class PlotBars extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      scaleX,
      scaleY,
      getX,
      getY,
      typeX,
      domainX,
      formatY,
      width,
      height,
      color,
      opacity,
      align,
      series,
      maxBarWidth
    } = this.props;

    let [idx, len] = series;
    let w;
    let x;
    let m;

    if (typeX === "ordinal") {
      w = width / (domainX.length + 1);
    }
    else if (align === "left") {
      w = scaleX(data[0].x1) - scaleX(data[0].x0) - 1;
    }
    else {
      x = data.map(getX);
      m = _Math.min(x.map((n, i) => n - x[i - 1]).filter((n) => n > 0));
      w = Math.min(25, scaleX(m * 2) - scaleX(m));
    }

    w = Math.min(w, maxBarWidth);

    let bars = d3.select(this.refs.bars)
      .selectAll("rect")
      .data(data);

    let pairY = (d) => [0].concat(getY(d)).slice(-2);

    let diffY = (d) => d[1] - d[0];

    let fmt = formatY || ((y) => y);

    bars
      .enter()
      .append("rect")
      .merge(bars)
      .attr("x", (d, i) => scaleX(getX(d, i)) + (align === "left" ? 2 : (w / -2)) + ((w * idx) / len))
      .attr("y", (d) => scaleY(pairY(d)[1]))
      .attr("width", w / (len * 1.05))
      .attr("height", (d) => height - scaleY(diffY(pairY(d))))
      .attr("fill", color)
      .attr("fill-opacity", opacity)
      .attr("data-x", getX)
      .attr("data-y", pairY)
      .attr("data-tooltip", (d) => fmt(diffY(pairY(d))));

    bars
      .exit()
      .remove();
  }

  render() {
    return (
      <g className="mc-plot-bars" ref="bars">
      </g>
    );
  }
}

PlotBars.defaultProps = {
  color: "#304561",
  opacity: 1,
  align: "center",
  series: [0, 1],
  maxBarWidth: Infinity
};

module.exports = PlotBars;